export default "__VITE_ASSET__ClJtg2bb__"